import { Button } from '@mui/material';
import React from 'react';

type Props = {
  type?: any;
  text?: string;
  color?: string;
  style?: object;
  border?: boolean;
  disabled?: boolean;
  background?: string;
  onClick?: (e: any) => void;
  iconEnd?: React.ReactElement | boolean;
  iconStart?: React.ReactElement;
};

const CustomButton = ({
  type,
  style,
  border,
  onClick,
  iconEnd,
  text = '',
  iconStart,
  disabled = false,
  color = '#ffffff',
  background = '#005aa9',
}: Props) => {
  return (
    <Button
      style={{}}
      type={type}
      disableRipple
      onClick={(e: any) => onClick?.(e)}
      disabled={disabled}
      sx={{
        height: '40px',
        minWidth: '20px',
        padding: '0 16px',
        background: background,
        fontFamily: 'Inter',
        fontSize: '16px',
        lineHeight: '24px',
        border: border ? `1px solid ${color}` : 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        ...style,
        '&:hover': {
          background: background,
        },
        '&.Mui-disabled': {
          background: '#f0f0f0 !important',
          color: '#B2B2B2 !important',
        },
      }}>
      {iconStart && <span style={{ color: color, marginTop: '5px' }}>{iconStart}</span>}
      <span
        style={{
          color: disabled ? '#B2B2B2' : color,
          fontFamily: 'Lato',
          fontSize: ' 14px',
          lineHeight: '20px',
        }}>
        {text}
      </span>
      {iconEnd && <span style={{ color: color, marginTop: '5px' }}>{iconEnd}</span>}
    </Button>
  );
};

export default CustomButton;
